import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const GooglePlay = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.5636 11.2707L8.00004 8.70714L2.32628 14.3809C2.35025 14.4117 2.37539 14.4418 2.40164 14.4709C2.56397 14.6508 2.76501 14.7916 2.98963 14.8827C3.21425 14.9737 3.45659 15.0126 3.69841 14.9964C3.94024 14.9802 4.17523 14.9094 4.38571 14.7892L10.5636 11.2707Z"
      fill="currentColor"
    />
    <path
      d="M11.4682 10.761L8.70715 8.00004L11.4495 5.25767L13.8675 6.64257H13.8588C14.1383 6.79096 14.367 7.01966 14.5154 7.2992C14.6105 7.47988 14.669 7.67757 14.6874 7.88092C14.7059 8.08427 14.684 8.28926 14.623 8.48411C14.5619 8.67896 14.463 8.85984 14.3319 9.01634C14.2007 9.17283 14.0399 9.30187 13.8588 9.39604L11.4682 10.761Z"
      fill="currentColor"
    />
    <path
      d="M10.5503 4.74268L8.00004 7.29293L2.32554 1.61843C2.41146 1.50735 2.51223 1.40743 2.62574 1.32173C2.90314 1.1123 3.24142 0.999314 3.589 1C3.87678 1.00098 4.15918 1.078 4.4076 1.22326L10.5503 4.74268Z"
      fill="currentColor"
    />
    <path d="M2 2.70711V13.293L7.29293 8.00004L2 2.70711Z" fill="currentColor" />
  </Icon>
));

export default GooglePlay;
